import type { AppInkButtonProps } from "./AppInkButton.Props";

export const isAppInkButtonProps = (props: {
  type: string;
}): props is AppInkButtonProps => {
  return (props as AppInkButtonProps).type === "AppInkButtonProps";
};
